import React, { useState } from "react";

import "./cohortComponent.css";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import leftArrow from "../../../../assests/leftArrow.svg";
import profile from "../../../../assests/gprofile.svg";
import warehouse from "../../../../assests/warehouse.svg";
import cohorts from "../../../../assests/cohorts.svg";
import search from "../../../../assests/search.svg"
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";
import { useParams } from "react-router-dom";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import cohortVmImg from "../../../../assests/cohortVmImg.svg"
import cohortType from "../../../../assests/cohortType.svg"
import locationIcon from "../../../../assests/locationIcon.svg"


const CohortDetailsComponent = (props) => {
  const { userid } = useParams();

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);

  };
  const buttonStyle = {
    padding: "4px 20px",
    fontSize: "14px",
    color: "#14AE78",
    borderColor: "#14AE78",
    backgroundColor: "transparent",
  };

  const handleButtonClick = () => {
    navigate(`/updatewarehouse/${userid}`);
  };
  const imgwidth = {
    width: "26px",
  };
  const colorAccess = { backgroundColor: "rgba(242,186,186, 0.43)", textAlign: "center" };

  const cohortDetailsData = props?.cohortDetailsData;
  const [searchQuery, setSearchQuery] = useState("");


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };


  const filteredUsers = cohortDetailsData?.users?.filter((user) => {
    const userId = user.id.toString();
    const userPhone = user.phone.toString();
    const userName = user.name ? user.name.toLowerCase() : "";
    return userId.includes(searchQuery) || userName.includes(searchQuery) || userPhone.includes(searchQuery);
  });

  const [machineSearchQuery, setMachineSearchQuery] = useState("");


  const handleMachineSearchChange = (event) => {
    setMachineSearchQuery(event.target.value.toLowerCase());
  };


  const filteredMachines = cohortDetailsData?.machines?.filter((machine) => {
    const machineId = machine.id.toString();
    const machineName = machine.name.toLowerCase();
    return (
      machineId.includes(machineSearchQuery) ||
      machineName.includes(machineSearchQuery)
    );
  });
  return (
    <div className="main-div" >
      <div>
        <Sidebar />
      </div>
      {props.loading ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <div style={{height:"100vh", width:"90vw", overflow:"auto"}}>
          <div
            style={{ marginLeft: "42px", marginTop: "18px", display: "flex" }}
          >
            <img
              onClick={handleBack}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />
            <h2 style={{ marginLeft: "10px" }}>
              Cohort ID: {cohortDetailsData?.id}{" "}
            </h2>
          </div>
          <div className="cohortsection1">
            <div className="cohortbasicInfo">
              <div className="basicSec">
                <p style={{ fontSize: "16px" }}>
                  <img src={profile} alt="" /> Cohort Details
                </p>
              </div>

              <div className="cohortbackgroundImg">
                <div className="right-divactive" style={{ display: "flex" }}>
                  <div className="cohortactiveDiv">
                    <div className="designationD">
                      <img
                        style={{
                          width: "78px",
                          height: "79px",
                          borderRadius: "36.22214px",
                        }}
                        src={cohortVmImg}
                        alt=""
                      />

                      <div style={{ marginRight: "20px", width: "210px" }}>
                        <p>{cohortDetailsData?.name}</p>
                        <span
                          style={{
                            fontSize: "14px",
                            color: "rgba(61,61,61, 0.7)",
                          }}
                        >
                          {/* {data && data.userRole.role_name} */}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        flexDirection: "column",
                        marginLeft: "48px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "10px",
                        }}
                      >
                        <img
                          src={cohortType}
                          alt="Cohort Type"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <p style={{ margin: 0 }}>
                          Cohort type: {cohortDetailsData?.cohortTypeName}
                        </p>
                      </div>


                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <img
                          src={locationIcon}
                          alt="Location Icon"
                          style={{ width: "20px", height: "20px" }}
                        />
                        <p style={{ margin: 0 }}>
                          Area Name: {cohortDetailsData?.areaName}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="cohortLeftSec">
              <div className="warehouseSec">
                <p style={{ fontSize: "16px" }}>
                  <img src={warehouse} alt="" /> User List
                </p>
                {/* <Button
                  style={buttonStyle}
                  variant="outlined"
                  onClick={handleButtonClick}
                >
                  Edit
                </Button> */}
              </div>
              <div>
                <div
                  style={{
                    padding: "12px",
                    position: "relative",
                    width: "20vw",
                    border: "none",
                  }}
                >

                  <input
                    type="search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    style={{
                      borderRadius: "12px",
                      padding: "10px 40px 10px 18px",
                      width: "100%",
                      boxSizing: "border-box",
                    }}
                    placeholder="Search by User ID or User Name"
                  />
                  <img
                    src={search}
                    alt="search"
                    style={{
                      position: "absolute",
                      right: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>

                <div style={{ height: "32vh", overflowY: "scroll" }}>
                  <Table striped hover style={{ backgroundColor: "#fff" }}>
                    <thead>
                      <tr>
                        <th>User ID</th>
                        <th>User Name</th>
                        <th>Contact No</th>
                      </tr>
                    </thead>
                    <tbody style={{ height: "10vh", overflowY: "scroll" }}>

                      {filteredUsers?.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td style={{ textAlign: "center" }}>{item.id}</td>
                            <td style={{ textAlign: "center" }}>{item.name}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.phone}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>


          </div>

          <div className="cohortsDetails">
            <div className="cohortsSec">
              <p style={{ fontSize: "16px" }}>
                <img src={cohorts} alt="" /> Vending Machine List
              </p>
              {/* <Button
                style={buttonStyle}
                variant="outlined"
                onClick={handleButtonClick}
              >
                Edit
              </Button> */}
            </div>

            <div className="tableContainer">
              <div
                style={{
                  padding: "12px",
                  position: "relative",
                  width: "24vw",
                  border: "none",
                }}
              >

                <input
                  type="search"
                  value={machineSearchQuery}
                  onChange={handleMachineSearchChange}
                  style={{
                    borderRadius: "12px",
                    padding: "10px 40px 10px 18px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                  placeholder="Search by V.M ID or V.M Name"
                />
                <img
                  src={search}
                  alt="search"
                  style={{
                    position: "absolute",
                    right: "18px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "20px",
                    height: "20px",
                  }}
                />
              </div>

              <div style={{ height: "40vh", overflowY: "scroll" }}>

                <Table striped hover style={{ backgroundColor: "#fff" }}>
                  <thead>
                    <tr>
                      <th>V.M ID</th>
                      <th>V.M Name</th>
                      <th>City</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>

                    {filteredMachines?.map((item) => (
                      <tr key={item.id}>
                        <td style={{ textAlign: "center" }}>{item.id}</td>
                        <td style={{ textAlign: "center" }}>{item.name}</td>
                        <td style={{ textAlign: "center" }}>
                          {item.area_name}
                        </td>
                        <td>
                          <div style={colorAccess} className="citypayout">
                            <p>{item.cohort_type_name}</p>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>


        </div>
      )}
    </div>
  );
};

export default CohortDetailsComponent;
